
import React from 'react'
import Form from './Form'
import CountrySelect from './CountrySelect'
import TextInputField from './TextInputField'

// TODO: use american address for AddressInputs default

/**
 * AddressInputs component.
 */

export default function AddressInputs({ address_line1, address_city, address_state, address_zip, address_country, required = true }) {
  return <React.Fragment>
    <Form.Row>
      <TextInputField
        name="address_line1"
        defaultValue={address_line1}
        width="100%"
        label="Address"
        placeholder="165 London Road"
        spellCheck={false}
        required={required} />
    </Form.Row>
    <Form.Row>
      <TextInputField
        name="address_city"
        defaultValue={address_city}
        width="100%"
        label="City"
        placeholder="London"
        required={required} />
      <TextInputField
        name="address_state"
        defaultValue={address_state}
        width="100%"
        label="State"
        placeholder="Croydon" />
      <TextInputField
        name="address_zip"
        defaultValue={address_zip}
        width="100%"
        label="Postal code"
        placeholder="CR0"
        required={required} />
    </Form.Row>
    <Form.Row>
      <CountrySelect
        name="address_country"
        defaultValue={address_country}
        label="Country"
        required={required} />
    </Form.Row>
  </React.Fragment>
}